<template>
  <div class="product-template __donate __uob">
    <div class="wrapper-header">
      <div class="col-md-push-3 col-md-6">
        <h1 data-v-1f20e9ef="" class="text-center mb-20 mt-30">
           <img src="/static/img/uob/logo-uobxtcfexffg@2x.png" srcset="/static/img/uob/logo-uobxtcfexffg@2x.png" alt="UOB X TCFE x FoodForGood" style="width: 100%; max-width: 450px" class="pd-15 ma-auto d-block" />
        </h1>
      </div>
    </div>
    <div class="container pd-sm-0">
      <div class="col-md-push-1 col-md-10 col-lg-push-1 col-md-10">
      <h1 class="page-title text-center">ร่วมบริจาค</h1>
      <h3 class="text-center">โครงการ 2022 UOB Global Heartbeat Run/Walk<br />ชวนคุณร่วมเป็น <strong>“ผู้ให้”</strong></h3>
        <div class="product product--inline">
          <div class="product__block--form">
            <div class="radius block shadow">
              <product-donate-choice
              :show-donate-type="true"
              :product="product"
              v-model="product.price"
              ref="donateChoice"
              classes="col-1-5" />
              <div class="row">
                <div class="col-sm-12 col-md-6">
                    <!-- ตำแหน่ง -->
                    <div class="pt-15">
                        <div><strong>ระบุตำแหน่ง <span style="color: #E82B27">*</span></strong></div> 
                        <div class="form__select">
                            <!-- rewardConfigChoice (ตำแหน่ง) -->
                            <select v-model="attributes.info.rewardConfigChoice">
                                <option value="">-- โปรดระบุตำแหน่ง --</option>
                                <option
                                v-for="LevelOption in LevelOptions"
                                :key="LevelOption.text"
                                :value="LevelOption.description"
                                >
                                {{ LevelOption.description }}
                                </option>
                            </select>
                        </div>
                        <div class="alert alert--error" v-if="error.rewardConfigChoice">กรุณาระบุตำแหน่ง</div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <!-- หน่วยงาน -->
                    <div class="pt-15">
                        <div><strong>ระบุหน่วยงานของท่าน <span style="color: #E82B27">*</span></strong></div> 
                        <div class="form__select">
                            <!-- rewardConfigText (หน่วยงาน) -->
                            <select v-model="attributes.info.rewardConfigText">
                                <option value="">-- โปรดระบุหน่วยงาน --</option>
                                <option
                                v-for="FunctionOption in FunctionOptions"
                                :key="FunctionOption.text"
                                :value="FunctionOption.description"
                                >
                                {{ FunctionOption.description }}
                                </option>
                            </select>
                        </div>
                        <div class="alert alert--error" v-if="error.rewardConfigText">กรุณาระบุหน่วยงานของท่าน</div>
                    </div>
                </div>
              </div>
              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false" />

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction" />
              <div class="text-center">
                <button type="button" class="btn btn--purple btn--default" @click.prevent="donate">บริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'
  export default {
    name: 'ProductTemplateUOB',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice
    },
    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },
    data () {
      return {
        attributes: {
          info: {
            name: '',
            rewardConfigChoice: '',
            rewardConfigText: ''
          },
          page: ''
        },
        error: {
          rewardConfigChoice: false,
          rewardConfigText: false
        }
      }
    },
    computed: {
      // ตำแหน่ง
      LevelOptions () {
        // 1:Managing Director,2:Executive Director
        return this.product.meta.donation_level_option.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      },
      // หน่วยงาน
      FunctionOptions () {
        // 1:Personal Financial Services, 2:Project Management Office
        return this.product.meta.donation_function_option.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      }
    },
    methods: {
      validate () {
        this.error.rewardConfigChoice = false
        this.error.rewardConfigText = false
        let valid = true
        const {info} = this.attributes
        // Validate size selection.
        if (!info.rewardConfigChoice) {
          this.error.rewardConfigChoice = true
          valid = false
        } else if (!info.rewardConfigText) {
          this.error.rewardConfigText = true
          valid = false
        }
        return valid
      },
      async donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }
        if (!this.validate()) {
          return
        }
        // Clear previous cart info.
        await this.$store.dispatch('clearCart')
        // Add donation product to cart and go to checkout.
        this.$refs.cartAction.buyNow()
      }
    }
  }
</script>

<style lang="scss" scoped>
  h1.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    font-size: 2em;
    font-weight: 400;
    margin-bottom: 15px;
  }

  h3.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  }
  .block { background: #fff; }
  .btn--default {
    margin: 20px auto 10px;
  }

</style>



// WEBPACK FOOTER //
// uob-default.vue?3b0e2416